module.exports = __webpack_public_path__ + "img/saturn3.331448d1.png";